/* Kits: one click puts every product of the kit into the cart, with no page reload.
   Used by the header dropdown and by the Combos page. A link keeps its href, so it
   still works if this script never runs. */
(function () {
  if (window.__comboKitsInit) return;
  window.__comboKitsInit = true;

  function parseItems(raw) {
    return (raw || '').split(',').filter(Boolean).map(function (pair) {
      var bits = pair.split(':');
      return { id: Number(bits[0]), quantity: Number(bits[1] || 1) };
    }).filter(function (it) { return it.id; });
  }

  function openDrawer() {
    /* The cart drawer is re-rendered right after an add, which drops the "show"
       class, so open it again once the new markup has landed. */
    [0, 350, 800].forEach(function (wait) {
      setTimeout(function () {
        var oc = document.getElementById('offcanvas-cart');
        if (!oc) return;
        if (oc.classList.contains('show')) return;
        if (window.bootstrap) {
          try { window.bootstrap.Offcanvas.getOrCreateInstance(oc).show(); } catch (e) {}
        }
        /* Last resort: the header's own cart button, the same path a shopper uses. */
        if (!oc.classList.contains('show') && wait > 0) {
          var trigger = document.querySelector('[data-bs-toggle="offcanvas"][href="#offcanvas-cart"], [data-bs-toggle="offcanvas"][data-bs-target="#offcanvas-cart"]');
          if (trigger) trigger.click();
        }
      }, wait);
    });
  }

  function flash(el, text) {
    if (!el) return;
    var label = el.querySelector('[data-kit-label]') || el;
    var was = label.textContent;
    label.textContent = text;
    setTimeout(function () { label.textContent = was; el.classList.remove('is-busy'); }, 1600);
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-combo-add]');
    if (!el) return;
    var items = parseItems(el.getAttribute('data-combo-add'));
    if (!items.length) return;          /* nothing to add: let the link do its thing */
    e.preventDefault();
    if (el.classList.contains('is-busy')) return;
    el.classList.add('is-busy');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: ['cart-count-badge', 'offcanvas-cart'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.d;
        /* Open first: whatever the theme does with the cart afterwards, the drawer
           is already on its way, and openDrawer re-opens it if a re-render closes it. */
        openDrawer();
        flash(el, el.getAttribute('data-added-label') || 'Added');
        try {
          window.dispatchEvent(new CustomEvent('kt.cart.added', { detail: res.d }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          var cc = document.querySelector('cart-container');
          if (cc && res.d.sections && typeof cc.reloadCartElements === 'function') {
            cc.reloadCartElements(res.d.sections);
          }
        } catch (err) { /* the cart still has the items; the drawer shows them on open */ }
        /* Close the header dropdown so the cart drawer is not behind it. */
        var dd = el.closest('.dropdown-menu');
        if (dd) dd.parentNode.classList.remove('mm-open', 'show');
      })
      .catch(function () {
        flash(el, el.getAttribute('data-error-label') || 'Could not add');
      });
  });
})();
